import { colorBaseGreyWarm50, layoutMarginMedium, ProductHeading } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { shouldShowAds } from '../../util/ads-utils';
import { AdsPrimisNormal, AdsPrimisWide } from '../Ads';
import DocumentContext from '../DocumentPage/DocumentContext';
import type { GridLayout } from '../DocumentPage/useGridLayout';

const Root = styled.div`
    padding: ${layoutMarginMedium};
    background-color: ${colorBaseGreyWarm50};
    grid-area: see-more;
`;

const Ad: React.FC<{ layout: GridLayout }> = ({ layout }: { layout: GridLayout }) => {
    switch (layout) {
        case 'wideScreen':
            return <AdsPrimisWide />;
        case 'twoColumn':
            return <AdsPrimisNormal />;
        default:
            return null;
    }
};

export const SeeMore: React.FC = () => {
    const context = useContext(DocumentContext);
    const {
        appState: {
            currentLayout: { name: layout },
            readerViewState: [readerViewState],
        },
    } = context;
    if (readerViewState !== 'small' || !shouldShowAds({ context })) return null;

    return (
        <Root>
            <ProductHeading level={2} step="negative-2">
                See More
            </ProductHeading>
            <Ad layout={layout} />
        </Root>
    );
};
